export const interpolateString = (str: string, obj: any): string =>
  str.replace(/\${(.*?)}/g, (x, g) => obj[g])

export const isEmpty = (str: string): boolean => str === null || str === undefined || str.length === 0
